module.exports = __webpack_public_path__ + "img/stock1.e3c5ff31.png";